/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import Paragraf from '../services/Paragraf';
import Parag from '../services/Parag';
import HeadingServices from '../services/HeadingServices'

export default function PrivacyPolicy({ datasPrivacy }) {
    return (
        <>
            <HeadingServices lowerTitle={datasPrivacy.title} />
            <div className="container">
                <div className="row my-3">
                    <div className="col my-md-3 my-1">
                        <p className="text-5 line-height-2 pt-3 text-dark text-justified">
                            {datasPrivacy.pOne}
                            {datasPrivacy.pOneLink && <Link href={"https://" + datasPrivacy.pOneLink}>
                                <a target="_blank"> 
                                <strong className="font-weight-extra-bold"> {datasPrivacy.pOneLink}  </strong></a>
                            </Link>}
                            {datasPrivacy.spanOne}
                            <strong className="font-weight-extra-bold text-dark"> {datasPrivacy.spanBoldOne}  </strong>
                            {datasPrivacy.spanTwo}
                            <strong className="font-weight-extra-bold text-dark"> {datasPrivacy.spanBoldTwo}  </strong>
                            {datasPrivacy.spanThree}
                            <strong className="font-weight-extra-bold text-dark"> {datasPrivacy.spanBoldThree}  </strong>
                            {datasPrivacy.spanFour}
                        </p>
                        <Paragraf parag={datasPrivacy.pTwo} />
                        <Paragraf parag={datasPrivacy.pThree} />

                        <p className="text-5 line-height-2 text-dark text-justified">
                            {datasPrivacy.pFour}
                            <strong className="font-weight-extra-bold text-dark"> {datasPrivacy.spanBoldFour}  </strong>
                            {datasPrivacy.spanFive}

                        </p>

                        <Paragraf parag={datasPrivacy.pFive} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pSixTitle} </h4>
                        <Paragraf parag={datasPrivacy.pSix} />
                        <ul>
                            {datasPrivacy.pSevenList && datasPrivacy.pSevenList.map(item =>
                                <li className="text-5 line-height-2 text-dark text-justified" key={item}>
                                    {item}
                                </li>)}
                        </ul>
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pSevenTitle} </h4>
                        <Paragraf parag={datasPrivacy.pSeven} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pEightTitle} </h4>
                        <Paragraf parag={datasPrivacy.pEight} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pNineTitle} </h4>
                        <Paragraf parag={datasPrivacy.pNine} />
                        <p className="text-5 line-height-2 text-dark text-justified">
                            <strong className="font-weight-extra-bold text-dark">
                                {datasPrivacy.pTenTitle}  </strong>
                            {datasPrivacy.pTen}
                        </p>
                        <p className="text-5 line-height-2 text-dark text-justified">
                            <strong className="font-weight-extra-bold text-dark">
                                {datasPrivacy.pElevenTitle}  </strong>
                            {datasPrivacy.pEleven}
                        </p>
                        <p className="text-5 line-height-2 text-dark text-justified">
                            <strong className="font-weight-extra-bold text-dark">
                                {datasPrivacy.pTwelveTitle}  </strong>
                            {datasPrivacy.pTwelve}
                        </p>
                        <p className="text-5 line-height-2 text-dark text-justified">
                            <strong className="font-weight-extra-bold text-dark">
                                {datasPrivacy.pThirteenTitle}  </strong>
                            {datasPrivacy.pThirteen}
                        </p>
                        <Paragraf parag={datasPrivacy.pFourtien} />
                        <h4 className="font-weight-extra-bold text-center text-dark">{datasPrivacy.tableTitle} </h4>
                        <table className="table table-bordered">
                            <tbody className="border-1">
                                {datasPrivacy.tableDatas && datasPrivacy.tableDatas.map(item =>
                                    <tr key={item.itemOne} className="text-5 line-height-2 text-justifed">
                                        <td> {item.itemOne} </td>
                                        <td> {item.itemTwo} </td>
                                    </tr>)}
                            </tbody>
                        </table>
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pFourtienTitle} </h4>
                        <ul>
                            {datasPrivacy.pFourtienList && datasPrivacy.pFourtienList.map(item =>
                                <li className="text-5 line-height-2 text-dark text-justified" key={item}>
                                    {item}
                                </li>)}
                        </ul>
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pFifteenTitle} </h4>
                        <p className="text-5 line-height-2 text-dark text-justified">
                            {datasPrivacy.pFifteen}
                            {datasPrivacy.pFifteenLink && <Link href={"https://" +datasPrivacy.pFifteenLink}>
                                <a target="_blank"> <strong className="font-weight-extra-bold">
                                    {datasPrivacy.pFifteenLink}  </strong></a>
                            </Link>}
                            {datasPrivacy.pSpanFifteen}
                        </p>
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pSixteenTitle} </h4>
                        <Paragraf parag={datasPrivacy.pSixteen} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pSeventeenTitle} </h4>
                        <p className="text-5 line-height-2 text-dark text-justified">
                            {datasPrivacy.pSeventeen}
                            {datasPrivacy.pLinkBelow && <Link href={"https://"+ datasPrivacy.pLinkBelow}>
                                <a target="_blank"> <strong className="font-weight-extra-bold">
                                    {datasPrivacy.pLinkBelow}  </strong></a>
                            </Link>}
                            {datasPrivacy.pLast}
                        </p>
                        <Paragraf parag={datasPrivacy.pEighteen} />
                        <Paragraf parag={datasPrivacy.pNineteen} />
                        <Paragraf parag={datasPrivacy.pTwenty} />
                        <Paragraf parag={datasPrivacy.pTwentyOne} />
                        {datasPrivacy.pTwentyOneList && datasPrivacy.pTwentyOneList.map(item => <Paragraf key={item} parag={item}
                            styles={{ "textIndent": "1em" }} />)}
                        <Paragraf parag={datasPrivacy.pTwentyTwo} />
                        <Paragraf parag={datasPrivacy.pTwentyThree} />
                        <Paragraf parag={datasPrivacy.pTwentyFour} />
                        <Paragraf parag={datasPrivacy.pTwentyFive} />
                        <Paragraf parag={datasPrivacy.pTwentySix} />
                        <Paragraf parag={datasPrivacy.pTwentySeven} />
                        <Paragraf parag={datasPrivacy.pTwentyEight} />
                        <Paragraf parag={datasPrivacy.pTwentyNine} />
                        <Paragraf parag={datasPrivacy.pThirty} />
                        <Paragraf parag={datasPrivacy.pThirtyOne} />
                        <Paragraf parag={datasPrivacy.pThirtyTwo} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.pThirtyThreeTitle} </h4>
                        {datasPrivacy.p33List && datasPrivacy.p33List.map(item =>
                            <Paragraf key={item} parag={item} />)}
                        {datasPrivacy.p34List && datasPrivacy.p34List.map(item =>{
                            let split = item.split(":");
                            return (<Parag key={split}
                                parag={item}
                                styles={{ "textIndent": "1em" }}>
                                <span> {item} </span>
                                {/* <Link href={split[1] + ":" + split[2]}>
                                    <a target="_blank">
                                        {split[1] + ":"+ split[2] }
                                    </a>
                                </Link> */}
                        </Parag>)})}
                        <Paragraf parag={datasPrivacy.p35} />
                        {datasPrivacy.p36List && datasPrivacy.p36List.map(item =>
                            <Paragraf key={item} parag={item} styles={{ "textIndent": "1em" }} />)}
                        <Paragraf parag={datasPrivacy.p37} />
                        <Paragraf parag={datasPrivacy.p38} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p50t} </h4>
                        {datasPrivacy.p50List && datasPrivacy.p50List.map(item =>
                            <Paragraf key={item} parag={item} />)}
                        <Paragraf parag={datasPrivacy.p51} styles={{ "textIndent": "1em" }} />
                        <Paragraf parag={datasPrivacy.p52} />
                        <Paragraf parag={datasPrivacy.p53} styles={{ "textIndent": "1em" }} />
                        {datasPrivacy.p54List && datasPrivacy.p54List.map(item =>
                            <Paragraf key={item} parag={item} />)}
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p65t} </h4>
                        <Paragraf parag={datasPrivacy.p65} />
                        <Paragraf parag={datasPrivacy.p66} />
                        {datasPrivacy.p66List && datasPrivacy.p66List.map(item =>
                            <Parag key={item} parag={item} styles={{ "textIndent": "1em" }}>
                                <span> {item} </span>
                                {/* <Link href={item.split(" ")[1].trim()}>
                                    <a target="_blank">
                                        {item.split(" ")[1].trim()}
                                    </a>
                                </Link> */}
                            </Parag>)}
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p67t} </h4>
                        {datasPrivacy.p68List && datasPrivacy.p68List.map(item =>
                            <Paragraf key={item} parag={item} />)}
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p72t} </h4>
                        {datasPrivacy.p73List && datasPrivacy.p73List.map(item =>
                            <Paragraf key={item} parag={item} />)}
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p76t} </h4>
                        {datasPrivacy.p76List && datasPrivacy.p76List.map(item =>
                            <Paragraf key={item} parag={item} />)}
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p77t} </h4>
                        <Paragraf parag={datasPrivacy.p77} />
                        {datasPrivacy.p77 && <div style={{width:"11em", height:"2em", margin:"1em"}}>
                            <img 
                                width="100%"
                                height="100%"
                                alt="privacy"
                                src="/images/mail/info.png" />
                            </div>}
                        {datasPrivacy.p77List && datasPrivacy.p77List.map(item =>
                            <Paragraf key={item} parag={item}/>)}
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p80t} </h4>
                        <Paragraf parag={datasPrivacy.p80} />
                        {datasPrivacy.p86 && <div  style={{width:"11em", height:"2em", margin:"1em"}}>
                            <img 
                                width="100%"
                                height="100%"
                                alt="mail"
                                src="/images/mail/info.png" />
                            </div>}
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p81t} </h4>
                        <Paragraf parag={datasPrivacy.p82} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p83t} </h4>
                        <Paragraf parag={datasPrivacy.p83} />
                        {datasPrivacy.p84List && datasPrivacy.p84List.map(item =>
                            <Paragraf key={item} parag={item} styles={{ "textIndent": "1em" }}/>)}
                        <Paragraf parag={datasPrivacy.p85} />
                        <h4 className="font-weight-extra-bold text-dark">{datasPrivacy.p86t} </h4> 
                        <Paragraf parag={datasPrivacy.p86} />
                        {datasPrivacy.p86 && <div  style={{width:"11em", height:"2em", margin:"1em"}}>
                            <img 
                                width="100%"
                                height="100%"
                                alt="mail adress"
                                src="/images/mail/info.png" />
                            </div>}
                    </div>
                </div>
            </div>
        </>
    )
}
